import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Layout, Card, Modal, Alert, List, Spin,
  Menu,
  Button,
  Avatar,
  Dropdown,
  Typography,
  Space,
  theme,
  Row,
  Col,
  Grid,
  Drawer,
  Tooltip,
  Badge
} from 'antd';
import {
  MenuFoldOutlined, CheckOutlined, CalculatorOutlined,
  MenuUnfoldOutlined,CalendarOutlined,BookOutlined ,BarChartOutlined ,ScheduleOutlined ,LineChartOutlined ,
  UserOutlined,FileTextOutlined ,FileDoneOutlined ,CreditCardOutlined ,ApiOutlined ,
  LogoutOutlined,
  DashboardOutlined,
  MenuOutlined,
  BellOutlined,
  SettingOutlined,
  ProfileOutlined,
  DatabaseOutlined,
  TeamOutlined,  
  DollarOutlined,
  ApartmentOutlined,
  HomeOutlined,
  AppstoreOutlined,
  TagsOutlined  
} from '@ant-design/icons';
import axios from 'axios';
import './MainLayout.css';

import UserProfileScreen from '../pages/UserProfileScreen';
import CalculoPreciosModal from '../components/CalculoPreciosModal';

import {BASE_URL} from '../utils/constants'


const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);
  const [hotel, setHotel] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();

  const [hotelCodigo, setHotelCodigo] = useState(null);
  const [hoteles, setHoteles] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [loadingHoteles, setLoadingHoteles] = useState(false);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user') || '{}'));
  const [profileModalVisible, setProfileModalVisible] = useState(false);

  const { token } = theme.useToken();

  // Determinar tamaño de pantalla
  const isMobile = !screens.md;
  const isTablet = screens.md && !screens.lg;
  const isDesktop = screens.lg;

  const calculoModalRef = useRef();
  const [reservaData, setReservaData] = useState({
    contrato: '002',
    fechas: null,
    habitaciones: []
  });  

const getAvatarUrl = (avatarPath) => {
    if (!avatarPath) return null;
    
    // Si ya es una URL completa, devolverla tal cual
    if (avatarPath.startsWith('http://') || avatarPath.startsWith('https://')) {
      return avatarPath;
    }
    
    // Si empieza con /uploads, añadir BASE_URL
    if (avatarPath.startsWith('/uploads')) {
      return `${BASE_URL}${avatarPath}`;
    }
    
    // Si no empieza con /, añadirla
    if (!avatarPath.startsWith('/')) {
      return `${BASE_URL}/uploads/${avatarPath}`;
    }
    
    // Por defecto, añadir BASE_URL
    return `${BASE_URL}${avatarPath}`;
  };  

  useEffect(() => {
    fetchHotelInfo();
    fetchHoteles();
    fetchUserProfile();
  }, []);  

  // Ajustar collapsed automáticamente en mobile
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    } else if (isTablet) {
      setCollapsed(false);
    }
    fetchHotelInfo();
  }, [isMobile, isTablet]);

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/usuarios/profile`,
        { headers: { Authorization: `Bearer ${token}` } }
      );


      // console.log(" usuarios => ",response.data);
      

      if (response.data.success) {
        const userData = response.data.user;
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
      }
    } catch (error) {
      console.error('Error obteniendo perfil de usuario:', error);
    }
  };

  const fetchHoteles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/hoteles/listaHoteles`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        setHoteles(response.data.hoteles);
        
        if (response.data.hoteles.length > 0 && !hotelCodigo) {
          const primerHotel = response.data.hoteles[0];
          setSelectedHotel(primerHotel.codigo);
        }
      }
    } catch (error) {
      console.error('Error obteniendo lista de hoteles:', error);
    }
  };  

  const abrirCalculadora = () => {
    calculoModalRef.current?.openModal({
      contrato: reservaData.contrato,
      fechas: reservaData.fechas,
      habitaciones: reservaData.habitaciones
    });
  };

  const handleCalculoExitoso = (resultado) => {
    console.log('Resultado del cálculo:', resultado);
    // Aquí puedes usar el resultado para llenar campos de la reserva
  };

  const handleHotelClick = () => {
    setModalVisible(true);
  };

  const handleSelectHotel = async (codigoHotel) => {
    try {
      const token = localStorage.getItem('token');
      const hotelSeleccionado = hoteles.find(h => h.codigo === codigoHotel);
      if (hotelSeleccionado) {
        setHotel(hotelSeleccionado.nombre);
        setHotelCodigo(codigoHotel);
        setSelectedHotel(codigoHotel);

        updateUltimoHotel(codigoHotel);
        
        localStorage.setItem('hotelSeleccionado', JSON.stringify({
          codigo: codigoHotel,
          nombre: hotelSeleccionado.nombre,
          terminal: hotelSeleccionado.terminal
        }));
        
        setModalVisible(false);
        
        Modal.success({
          title: 'Hotel cambiado',
          content: `Ahora estás en: ${hotelSeleccionado.nombre}`,
          okText: 'Aceptar'
        });
      }
    } catch (error) {
      console.error('Error al cambiar de hotel:', error);
      Modal.error({
        title: 'Error',
        content: 'No se pudo cambiar el hotel seleccionado',
        okText: 'Aceptar'
      });
    }
  };    

  const renderHotelItem = (hotel) => (
    <List.Item
      style={{
        padding: '12px 16px',
        borderRadius: '8px',
        cursor: 'pointer',
        border: selectedHotel === hotel.codigo ? `2px solid ${token.colorPrimary}` : '1px solid #f0f0f0',
        backgroundColor: selectedHotel === hotel.codigo ? `${token.colorPrimary}08` : 'white',
        transition: 'all 0.3s',
        marginBottom: '8px'
      }}
      onClick={() => handleSelectHotel(hotel.codigo)}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Space>
              <Avatar 
                size="small"
                icon={<HomeOutlined />}
                style={{ 
                  backgroundColor: selectedHotel === hotel.codigo ? token.colorPrimary : '#f0f0f0',
                  color: selectedHotel === hotel.codigo ? 'white' : '#666'
                }}
              />
              <Text strong style={{ fontSize: '16px' }}>{hotel.nombre}</Text>
            </Space>
          </Col>
          {selectedHotel === hotel.codigo && (
            <Col>
              <CheckOutlined style={{ color: token.colorPrimary }} />
            </Col>
          )}
        </Row>
        <Row>
          <Col span={24}>
            <Space direction="vertical" size={2}>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Código: <Text strong>{hotel.codigo}</Text>
              </Text>
            </Space>
          </Col>
        </Row>
      </Space>
    </List.Item>
  );
  
  const updateUltimoHotel = async (codigoHotel) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${BASE_URL}/api/hoteles/ultimoHotel`,
        { codigoHotel },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error('Error cambiando estado de incidencia:', error);
    }
  };   

  const fetchHotelInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/gobernanta/hotel-info`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      if (response.data.success) {
        setHotel(response.data.hotel.nombre);
      }
    } catch (error) {
      console.error('Error obteniendo conteo de incidencias:', error);
    }
  };        

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Dashboard',
      onClick: () => {
        navigate('/dashboard');
        if (isMobile) setMobileDrawerVisible(false);
      }
    },
    {
      key: 'maestros',      
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <DatabaseOutlined   style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Maestros',
      children: [ // ← Esto crea un submenú
          {key: 'maestros-agencias',label: 'Agencias',icon: <TeamOutlined />,
            onClick: () => {
                  navigate('/agencias');
                  if (isMobile) setMobileDrawerVisible(false);
              }
          },
          {key: 'maestros-particulares',label: 'Particulares',icon: <UserOutlined />,
            onClick: () => {
                  navigate('/particulares');
                  if (isMobile) setMobileDrawerVisible(false);
              }
          },          
          {key: 'maestros-tarifas',label: 'Tarifas',icon: <DollarOutlined />,
            onClick: () => {
                  navigate('/tarifas');
                  if (isMobile) setMobileDrawerVisible(false);
              }
          },                    
          {key: 'maestros-tablasgenerales',
              icon: <ApartmentOutlined   style={{fontSize: isMobile ? '18px' : '16px' }} />,
              label: 'Tablas generales',
              children: [ // ← Esto crea un submenú
                  {key: 'maestros-tablasgenerales-habitaciones',
                      icon: <HomeOutlined   style={{fontSize: isMobile ? '18px' : '16px' }} />,
                      label: 'Habitaciones',
                      children: [ // ← Esto crea un submenú
                          {key: 'maestros-tablasgenerales-habitaciones-habitaciones',label: 'Habitaciones',icon: <HomeOutlined />,
                              onClick: () => {  navigate('/habitaciones'); if (isMobile) setMobileDrawerVisible(false);}
                          },
                          {key: 'maestros-tablasgenerales-habitaciones-tiposhabitaciones',label: 'Habitaciones Venta',icon: <TagsOutlined />,
                              onClick: () => {  navigate('/habitacionesventa'); if (isMobile) setMobileDrawerVisible(false);}
                          },                          
                      ]
                  },
                  {key: 'maestros-tablasgenerales-cargos',
                      icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                      label: 'Cargos',
                      children: [ // ← Esto crea un submenú                  
                          {
                            key: 'maestros-tablasgenerales-cargos',
                            icon: <DollarOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Cargos',
                            onClick: () => {  navigate('/cargos'); if (isMobile) setMobileDrawerVisible(false);}
                          },                           
                          {
                            key: 'maestros-tablasgenerales-secciones',
                            icon: <AppstoreOutlined style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Secciones',
                            onClick: () => {  navigate('/secciones'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                   
                      ]
                  },
                  {key: 'maestros-tablasgenerales-reservas',
                      icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                      label: 'Cargos',
                      children: [ // ← Esto crea un submenú                  
                          {
                            key: 'maestros-tablasgenerales-tiposcomunicacion',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Tipos de comunicación',
                            onClick: () => {  navigate('/tiposcomunicacion'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                
                          {
                            key: 'maestros-tablasgenerales-tiposfacturacion',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Tipos de facturación',
                            onClick: () => {  navigate('/tiposfacturacion'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                                          
                          {
                            key: 'maestros-tablasgenerales-reservasestados',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Estados de la reserva',
                            onClick: () => {  navigate('/reservasestados'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                                           
                          {
                            key: 'maestros-tablasgenerales-tiposregimen',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Tipos de regimen',
                            onClick: () => {  navigate('/tiposregimen'); if (isMobile) setMobileDrawerVisible(false);}
                          },                           
                          {
                            key: 'maestros-tablasgenerales-cancelaciones',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Cancelaciones',
                            onClick: () => {  navigate('/cancelaciones'); if (isMobile) setMobileDrawerVisible(false);}
                          },                           
                      ]
                  },                  
                          {
                            key: 'maestros-tablasgenerales-paises',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Paises',
                            onClick: () => {  navigate('/paises'); if (isMobile) setMobileDrawerVisible(false);}
                          },                  
                          {
                            key: 'maestros-tablasgenerales-provincias',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Provincias',
                            onClick: () => {  navigate('/provincias'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                            
                          {
                            key: 'maestros-tablasgenerales-tiposiva',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Tipos IVA',
                            onClick: () => {  navigate('/tiposiva'); if (isMobile) setMobileDrawerVisible(false);}
                          },

                          {
                            key: 'maestros-tablasgenerales-idiomas',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Idiomas',
                            onClick: () => {  navigate('/idiomas'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                               

                  
                          {
                            key: 'maestros-tablasgenerales-fpago',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Formas de cobro',
                            onClick: () => {  navigate('/formaspago'); if (isMobile) setMobileDrawerVisible(false);}
                          },                              
                          
                          {
                            key: 'maestros-tablasgenerales-series',
                            icon: <AppstoreOutlined  style={{fontSize: isMobile ? '18px' : '16px' }} />,
                            label: 'Series',
                            onClick: () => {  navigate('/series'); if (isMobile) setMobileDrawerVisible(false);}
                          },                                              
              ]
          },                   
      ]
    },   

    


    {
      key: 'reservas',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <BookOutlined  style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Reservas',
      onClick: () => {
        navigate('/reservas');
        if (isMobile) setMobileDrawerVisible(false);
      }
    },     
    {
          key: 'informes',      
          style:{ display: isMobile ? 'none' : 'block' },
          icon: <BarChartOutlined   style={{ 
            fontSize: isMobile ? '18px' : '16px' 
          }} />,
          label: 'Informes',
          children: [ // ← Esto crea un submenú
              {key: 'informes-ocupacion',label: 'Ocupación',icon: <ScheduleOutlined />,
                onClick: () => {
                      navigate('/ocupacion');
                      if (isMobile) setMobileDrawerVisible(false);
                  }
              },            
              {key: 'informes-planinghabitacionesventa',label: 'Planing habitaciones venta',icon: <LineChartOutlined />,
                onClick: () => {
                      navigate('/planinghabitacionesventa');
                      if (isMobile) setMobileDrawerVisible(false);
                  }
              },
          ]
    },    
    {
      key: 'ocupacion',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <CalendarOutlined  style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Ocupación',
        children: [ // ← Esto crea un submenú
              { key: 'ocupacion-localizarhuesped',
                style:{ display: isMobile ? 'none' : 'block' },
                icon: <CalendarOutlined  style={{ 
                    fontSize: isMobile ? '18px' : '16px' 
                }} />,
                label: 'Localizar huesped',
                onClick: () => {
                  navigate('/localizarhuesped');
                  if (isMobile) setMobileDrawerVisible(false);
                }
              },          
              { key: 'ocupacion-habitacioneslibres',
                style:{ display: isMobile ? 'none' : 'block' },
                icon: <CalendarOutlined  style={{ 
                    fontSize: isMobile ? '18px' : '16px' 
                }} />,
                label: 'Habitaciones libres',
                onClick: () => {
                  navigate('/habitacioneslibres');
                  if (isMobile) setMobileDrawerVisible(false);
                }
              },                        
              { key: 'ocupacion-checkincheckout',
                style:{ display: isMobile ? 'none' : 'block' },
                icon: <CalendarOutlined  style={{ 
                    fontSize: isMobile ? '18px' : '16px' 
                }} />,
                label: 'Checkin-Checkout',
                onClick: () => {
                  navigate('/checkin-checkout');
                  if (isMobile) setMobileDrawerVisible(false);
                }
              }              
        ],
    },    
    {
      key: 'planinghabitaciones',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <CalendarOutlined  style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Planing habitaciones',
      onClick: () => {
        navigate('/planinghabitaciones');
        if (isMobile) setMobileDrawerVisible(false);
      }
    },       
    {
      key: 'previsiones',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <CalendarOutlined style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Previsiones',
      children: [ // ← Esto crea un submenú
              {key: 'previsiones-entradassalidas',label: 'Entradas / Salidas',
                  onClick: () => {
                          navigate('/previsionentradassalidas');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              }, 
              {key: 'previsiones-serviciococina',label: 'Servicio cocina',
                  onClick: () => {
                          navigate('/serviciococina');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },               
              {key: 'previsiones-panellistados',label: 'Panel listados',
                  onClick: () => {
                          navigate('/panellistados');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },                             

      ]
      
    },     
    
    {
      key: 'facturacion',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <FileTextOutlined />,
      label: 'Facturación',
      children:[
              {
                key: 'facturas',
                icon: <FileDoneOutlined />,
                label: 'Facturas',
                onClick: () => {
                          navigate('/facturas');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },
              {
                key: 'cobros',
                icon: <CreditCardOutlined />,
                label: 'Cobros / Pagos',
              }              
            ]
    },

    {
      key: 'gobernanta',
      icon: <TeamOutlined style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Gobernanta',
      children:[
              {
                key: 'gobernanta-listado',
                style:{ display: isMobile ? 'none' : 'block' },
                icon: <FileDoneOutlined />,
                label: 'Listado',
                onClick: () => {
                  navigate('/listadogobernanta')
                  if (isMobile) setMobileDrawerVisible(false);
                }
              },
              {
                key: 'gobernanta-habitaciones',
                icon: <FileDoneOutlined />,
                label: 'Habitaciones',
                onClick: () => {
                  navigate('/gobernanta')
                  if (isMobile) setMobileDrawerVisible(false);
                }
              },
      ]              
    },
    {
      key: 'comedor',
      icon: <TeamOutlined style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Comedor',
      onClick: () => {
        navigate('/comedor')
        if (isMobile) setMobileDrawerVisible(false);
      }
    },    
    {
      key: 'incidencias',
      icon: <TeamOutlined style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Incidencias',
      onClick: () => {
        navigate('/incidencias')
        if (isMobile) setMobileDrawerVisible(false);
      }
    },        
    {
      key: 'integraciones',
      icon: <ApiOutlined />,
      label: 'Integraciones',
      children:[
              {
                key: 'Importar_reservas',
                icon: <FileDoneOutlined />,
                label: 'Importar reservas',
                onClick: () => {
                          navigate('/importarreservas');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },  
              {
                key: 'Importar_reservas_mapeos',
                icon: <FileDoneOutlined />,
                label: 'Importar reservas Mapeos',
                onClick: () => {
                          navigate('/xmlconfiguracion');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },                      
              {
                key: 'Synergy',
                icon: <FileDoneOutlined />,
                label: 'Synergy',
                onClick: () => {
                          navigate('/controlsynergy');
                          if (isMobile) setMobileDrawerVisible(false);
                        }
              },
            ]     
    },
    {
      key: 'settings',
      style:{ display: isMobile ? 'none' : 'block' },
      icon: <SettingOutlined  style={{ 
        fontSize: isMobile ? '18px' : '16px' 
      }} />,
      label: 'Configuración',
      onClick: () => {
        console.log('Configuración - por implementar');
        if (isMobile) setMobileDrawerVisible(false);
      }
    }
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <ProfileOutlined />,
      label: 'Mi Perfil',
      onClick: () => setProfileModalVisible(true)
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Configuración',
      onClick: () => console.log('Ir a configuración')
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      danger: true,
      onClick: handleLogout
    }
  ];

  const userMenu = (
    <Menu items={userMenuItems} />
  );

  // Sider para desktop/tablet
  const renderSider = () => (
    <Sider 
      trigger={null} 
      collapsible 
      collapsed={collapsed}
      theme="dark"
      width={isTablet ? 200 : 240}
      collapsedWidth={isMobile ? 0 : 80}
      style={{
        height: '100vh',
        position: isMobile ? 'fixed' : 'sticky',
        top: 0,
        left: 0,
        zIndex: 100,
        overflow: 'auto'
      }}
      breakpoint="lg"
      onBreakpoint={(broken) => {
        if (broken) {
          setCollapsed(true);
        }
      }}
    >
      <div className="logo" style={{ 
        height: isMobile ? '60px' : '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'center',
        padding: collapsed ? '0' : '0 16px',
        overflow: 'hidden',
        transition: 'all 0.2s'
      }}>
        {collapsed ? (
          <Title level={4} style={{ 
            color: 'white', 
            margin: 0,
            fontSize: isMobile ? '16px' : '18px'
          }}>
            SG
          </Title>
        ) : (
          <Space align="center">
            <div style={{
              width: isTablet ? '32px' : '36px',
              height: isTablet ? '32px' : '36px',
              backgroundColor: token.colorPrimary,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <HomeOutlined style={{ 
                color: 'white',
                fontSize: isTablet ? '16px' : '18px'
              }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Title
                level={isTablet ? 5 : 4}
                style={{
                  color: "white",
                  margin: 0,
                  fontSize: isTablet ? "14px" : "16px"
                }}
              >
                app Anphitrion
              </Title>

              <Button
                type="link"
                style={{ padding: 0, color: "white" }}
                onClick={handleHotelClick}
              >
                {hotel}
              </Button>
            </div>   
          </Space>
          
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['dashboard']}
        selectedKeys={[location.pathname.replace('/', '') || 'dashboard']}
        items={menuItems}
        style={{
          borderRight: 0,
          fontSize: isTablet ? '14px' : '15px'
        }}
      />
    </Sider>
  );

  // Drawer para mobile
  const renderMobileDrawer = () => (
    <Drawer
      title={
        <>
          <Text strong>app Anphitrion</Text>
          <Button
            type="link"
            style={{ padding: 0, marginTop: 4 }}
            onClick={() => handleHotelClick()}
          >
            {hotel}
          </Button>
        </>
      }
      placement="left"
      onClose={() => setMobileDrawerVisible(false)}
      open={mobileDrawerVisible}
      width={280}
      bodyStyle={{ 
        padding: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
      headerStyle={{ 
        padding: '16px 20px',
        borderBottom: `1px solid ${token.colorBgContainer}`
      }}
    >
      <div style={{ 
        padding: '16px 20px',
        borderBottom: `1px solid ${token.colorBgContainer}`
      }}>
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Avatar 
            size="large" 
            src={getAvatarUrl(user?.avatar)}
            icon={!user?.avatar && <UserOutlined />}
            style={{ 
              backgroundColor: user?.avatar ? 'transparent' : token.colorPrimary 
            }}
          />
          <div>
            <Text strong style={{ display: 'block' }}>
              {user?.UsuarioCorto || user?.usuario || 'Usuario'}
            </Text>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {user?.esmaster === 1 ? 'Administrador' : 'Usuario'}
            </Text>
          </div>
          
        </Space>
      </div>
      <Menu
        mode="inline"
        defaultSelectedKeys={['dashboard']}
        selectedKeys={[location.pathname.replace('/', '') || 'dashboard']}
        items={menuItems}
        style={{ 
          flex: 1,
          borderRight: 0,
          fontSize: '15px'
        }}
      />
      <div style={{ 
        padding: '16px 20px',
        borderTop: `1px solid ${token.colorBgContainer}`
      }}>
        <Button 
          block 
          danger 
          icon={<LogoutOutlined />}
          onClick={handleLogout}
        >
          Cerrar Sesión
        </Button>
      </div>
    </Drawer>
  );

  return (
    <Layout style={{ 
      minHeight: '100vh',
      background: token.colorBgContainer
    }}>
      {/* Mobile Drawer */}
      {isMobile && renderMobileDrawer()}

      {/* Desktop/Tablet Sider */}
      {!isMobile && renderSider()}

      <Layout style={{ 
        // marginLeft: isMobile ? 0 : (collapsed ? 80 : (isTablet ? 200 : 240)),
        // marginLeft: isMobile ? 0 : (collapsed ? 80 : (isTablet ? 200 : 240)),
        transition: 'all 0.2s'
      }}>
        <Header style={{ 
          padding: isMobile ? '0 12px' : '0 24px',
          background: token.colorBgContainer,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: isMobile ? '60px' : '64px',
          boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
          position: 'sticky',
          top: 0,
          zIndex: 99
        }}>
          <Space>
            {isMobile ? (
              <Button
                type="text"
                icon={<MenuOutlined style={{ fontSize: '18px' }} />}
                onClick={() => setMobileDrawerVisible(true)}
                style={{ width: 48, height: 48 }}
              />
            ) : (
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{ 
                  fontSize: '16px', 
                  width: 48, 
                  height: 48 
                }}
              />
            )}
            
            {/* CONTENIDO MODIFICADO: Mostrar título y hotel en móvil */}
            {isMobile && (
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                marginLeft: '8px',
                maxWidth: 'calc(100vw - 160px)', // Ajustar para no superponer con avatar
                overflow: 'hidden'
              }}>
                <Text strong style={{ 
                  fontSize: '16px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {location.pathname === '/dashboard' ? 'Dashboard' : 
                   location.pathname.includes('gobernanta') ? 'Gobernanta' : 
                   'app Anphitrion'}
                </Text>
                <Button
                  type="link"
                  style={{ 
                    padding: 0,
                    fontSize: '12px',
                    color: token.colorPrimary,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    height: 'auto',
                    lineHeight: 1.2,
                    textAlign: 'left'
                  }}
                  onClick={handleHotelClick}
                >
                  {hotel || 'Seleccionar Hotel'}
                </Button>
              </div>
            )}
            
            {/* Título para desktop/tablet */}
            {!isMobile && (
                <Text strong style={{ 
                    fontSize: isTablet ? '16px' : '18px'
                }}>
                    {location.pathname === '/dashboard' ? 'Dashboard' : 
                    location.pathname.includes('gobernanta') ? 'Gobernanta' : 
                    'app Anphitrion'} ::: <Button
                                              type="link"
                                              style={{ padding: 0, color: "black" }}
                                              onClick={handleHotelClick}
                                          >
                                              {hotel}
                                          </Button> :::

                <Button 
                                                              type="link"
                  icon={<CalculatorOutlined />}
                  onClick={abrirCalculadora}
                >
                  Calcular Precios
                </Button>

                <CalculoPreciosModal
                  ref={calculoModalRef}
                  onSuccess={handleCalculoExitoso}
                  titulo="Calculadora de Precios - Reservas"
                  width={1000}
                />



                </Text>
            )}
          </Space>
          
          <Space size={isMobile ? "small" : "middle"}>
            {/* Notificaciones (solo desktop/tablet) */}
            {!isMobile && (
              <Tooltip title="Notificaciones">
                <Badge count={3} size="small">
                  <Button
                    type="text"
                    icon={<BellOutlined style={{ fontSize: '18px' }} />}
                    shape="circle"
                  />
                </Badge>
              </Tooltip>
            )}

            {/* Perfil de usuario */}
            <Dropdown 
              menu={{ items: userMenuItems }}  
              placement="bottomRight"
              trigger={['click']}
              overlayStyle={{ minWidth: '200px' }}
            >
              <div style={{ 
                cursor: 'pointer', 
                padding: '4px 8px',
                borderRadius: '8px',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                ':hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}>
                <Avatar 
                  src={getAvatarUrl(user?.avatar)}
                  icon={!user?.avatar && <UserOutlined />}
                  size={isMobile ? 'default' : 'default'}
                  style={{ 
                    backgroundColor: user?.avatar ? 'transparent' : token.colorPrimary,
                    fontSize: isMobile ? '14px' : '16px'
                  }}
                />
                {!isMobile && (
                  <Space direction="vertical" size={0} style={{ 
                    marginLeft: '8px', 
                    lineHeight: 1.2 
                  }}>
                    <Text strong style={{ 
                      fontSize: isTablet ? '13px' : '14px'
                    }}>
                      {user?.UsuarioCorto || user?.usuario || 'Usuario'}
                    </Text>
                    <Text type="secondary" style={{ 
                      fontSize: isTablet ? '11px' : '12px'
                    }}>
                      {user?.esmaster === 1 ? 'Administrador' : 'Usuario'}
                    </Text>
                  </Space>
                )}
              </div>
            </Dropdown>
          </Space>
        </Header>
        
        <Content style={{ 
          margin: isMobile ? '12px' : '24px 16px',
          padding: isMobile ? '16px' : '24px',
          minHeight: 280,
          background: token.colorBgContainer,
          borderRadius: isMobile ? '8px' : '12px',
          overflow: 'auto'
        }}>
          <div style={{ 
            minHeight: 'calc(100vh - 200px)',
            maxWidth: '100%',
            overflowX: 'hidden'
          }}>
            <Outlet />
          </div>
        </Content>

        {/* Footer responsive */}
        {isDesktop && (
          <div style={{ 
            padding: '16px 24px',
            textAlign: 'center',
            borderTop: `1px solid ${token.colorBgContainer}`,
            background: 'rgba(0, 0, 0, 0.02)'
          }}>
            <Text type="secondary" style={{ fontSize: '14px' }}>
              Anphitrion Hotel Web © {new Date().getFullYear()} - v1.0.0
            </Text>
          </div>
        )}
      </Layout>

      {/* Modal de selección de hotel */}
      <Modal
        title={
          <Space>
            <HomeOutlined />
            <span>Seleccionar Hotel</span>
          </Space>
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>,
          selectedHotel && (
            <Button 
              key="select" 
              type="primary" 
              onClick={() => handleSelectHotel(selectedHotel)}
              loading={loadingHoteles}
            >
              Seleccionar
            </Button>
          )
        ]}
        width={isMobile ? '90%' : 500}
        centered
      >
        {loadingHoteles ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" tip="Cargando hoteles..." />
          </div>
        ) : hoteles.length === 0 ? (
          <Alert
            message="No hay hoteles disponibles"
            description="No se encontraron hoteles para mostrar."
            type="warning"
            showIcon
          />
        ) : (
          <Space direction="vertical" style={{ width: '100%' }} size="middle">
            <Text type="secondary">
              Selecciona uno de los hoteles disponibles:
            </Text>
            
            <List
              dataSource={hoteles}
              renderItem={renderHotelItem}
              locale={{ emptyText: 'No hay hoteles disponibles' }}
            />
            
            <Alert
              message="Información"
              description="Al cambiar de hotel, algunas configuraciones podrían verse afectadas."
              type="info"
              showIcon
              style={{ marginTop: '16px' }}
            />
          </Space>
        )}
      </Modal>

      {/* Modal del perfil de usuario */}
      <Modal
        title="Mi Perfil"
        open={profileModalVisible}
        onCancel={() => setProfileModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setProfileModalVisible(false)}>
            Cerrar
          </Button>
        ]}
        width={800}
        centered
        style={{ maxWidth: '95vw' }}
      >
        <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
          <UserProfileScreen 
            onClose={() => setProfileModalVisible(false)} 
            onProfileUpdate={(updatedUser) => {
              setUser(updatedUser);
              localStorage.setItem('user', JSON.stringify(updatedUser));
            }}
          />
        </div>
      </Modal>
    </Layout>
  );
};

export default MainLayout;